/**
 * Uygulama genelinde kullanılan yapılandırma değişkenleri
 */

// API'nin temel URL'i
export const API_BASE_URL: string = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001';

// Diğer yapılandırma değişkenleri buraya eklenebilir
export const APP_NAME: string = 'Riskmatik';

// 🔴 PLATFORM SÜRÜMÜ = TEK SSoT. Sidebar (UserSidebar) + public başlık (PublicHeader) badge'i buradan import eder
// (hardcode YASAK → drift imkansız). Sürüm notları (pages/surum-notlari.js) en güncel girdisi buna EŞİT olmalı —
// guard: `node frontend/scripts/check-version.mjs`. Değiştirince: bu sabit + surum-notlari RELEASES[0] birlikte güncellenir.
// ⚠ Mobil uygulama sürümü AYRIDIR (hakkinda.tsx APP_SURUM ↔ android-twa/twa-manifest.json appVersionName) — bununla karıştırma.
export const APP_VERSION: string = '4.0';
